<template>
  <App :session="session">

    <h4>BONIFICACIONES</h4>

    <i class="load" v-if="loading"></i>

    <div class="scroll" v-if="!loading">
<!--
      <i class="icon fa-solid fa-briefcase"></i>
      <select class="input">
        <option disabled selected>Periodo de cálculo</option>
        <option>30 Septiembre</option>
        <option>31 Agosto</option>
        <option>31 Julio</option>
      </select>
      <br>
      <br>
      <button class="button">Reporte</button> -->


      <h4>Bono Logro</h4>

      <!-- {{ pays }} -->

      <div v-for="(pay, i) in pays">

        <!-- <spam v-if="pay.name == 'DOBLE DIAMANTE'">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <i class="icon fas fa-gem" :class="{ green: pay.payed }"></i>
          <i class="icon fas fa-gem" :class="{ green: pay.payed }"></i>
        </spam>

        <spam v-else-if="pay.name == 'TRIPLE DIAMANTE'">
          <i class="icon fas fa-gem" :class="{ green: pay.payed }"></i>
          <i class="icon fas fa-gem" :class="{ green: pay.payed }"></i>
          <i class="icon fas fa-gem" :class="{ green: pay.payed }"></i>
        </spam>

        <spam v-else-if="pay.name == 'DIAMANTE ESTRELLA'">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <i class="icon fas fa-star" :class="{ green: pay.payed }"></i>
        </spam>

        <spam v-else>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <i class="icon fas fa-gem" :class="{ green: pay.payed }"></i>
        </spam> -->

        <i class="icon fas fa-gem" :class="{ green: pay.payed }"></i>

        <!-- <input class="input" readonly :value="pay._name" v-bind:style="{ width: 150 + 15 * i + 'px' }" :class="[pay.payed ? pay.name : '']"/> <br> -->

        <!-- <input class="input" readonly :value="pay.name + ' Bs ' + pay.value" v-bind:style="{ width: 150 + 15 * i + 'px' }" :class="[pay.payed ? pay.name : '']"/> <br> -->
        <input class="input" readonly :value="pay.name + ' Bs ' + pay.value" v-bind:style="{ width: 180 + 25 * i + 'px' }" :class="{ green: pay.payed }"/> <br>

      </div>


      <br>
      <br>

      <!-- <table>
        <thead>
          <tr>
            <th>Rango</th>
            <th>Pagado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="pay in pays">
            <td>{{ pay.name }}</td>
            <td>{{ pay.payed }}</td>
          </tr>
        </tbody>
      </table> <br> -->

      <!-- <div v-if="plan == 'master'">

        <h4>Premio en efectivo</h4>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th>Mes 1&nbsp; &nbsp; </th>
              <th>&nbsp; &nbsp; Mes 2</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="text-align: left;">Rango Diamante</td>
              <td>Bs 3 000</td>
              <td>
                <span v-if="bonuses['DIAMANTE'][0]">
                  {{ bonuses['DIAMANTE'][0] }}
                </span>
                <span v-else>No</span>
              </td>
              <td>
                <span v-if="bonuses['DIAMANTE'][1]">
                  {{ bonuses['DIAMANTE'][1] }}
                </span>
                <span v-else>No</span>
              </td>
            </tr>
            <tr>
              <td style="text-align: left;">Rango Embajador Elite</td>
              <td>Bs 30 000</td>
              <td>
                <span v-if="bonuses['EMBAJADOR ELITE'][0]">
                  {{ bonuses['EMBAJADOR ELITE'][0] }}
                </span>
                <span v-else>No</span>
              </td>
              <td>
                <span v-if="bonuses['EMBAJADOR ELITE'][1]">
                  {{ bonuses['EMBAJADOR ELITE'][1] }}
                </span>
                <span v-else>No</span>
              </td>
            </tr>
          </tbody>
        </table> <br>

      </div> -->

      <!-- <h4>Rango Rubi: 6/12</h4>
      <table>
        <thead>
          <tr>
            <th v-for="(bonus, i) in ruby">{{ i + 1 }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-for="bonus in ruby">{{ bonus }}</td>
          </tr>
        </tbody>
      </table> <br> -->

      <!-- <h4>Rango ORO: 21/24</h4>
      <table>
        <thead>
          <tr>
            <th v-for="(bonus, i) in gold">{{ i + 1 }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-for="bonus in gold">{{ bonus }}</td>
          </tr>
        </tbody>
      </table> <br>

      <h4>Rango Diamante: 6/9</h4>
      <table>
        <thead>
          <tr>
            <th v-for="(bonus, i) in diamond">{{ i + 1 }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-for="bonus in diamond">{{ bonus }}</td>
          </tr>
        </tbody>
      </table> <br> -->

    </div>
  </App>
</template>

<script>
import App from '@/views/layouts/App'
import api from '@/api'

export default {
  components: {
    App,
  },
  data() {
    return {
      loading: false,
      // pays: [],
      sapphire: [],
      ruby: [],
      gold: [],
      diamond: [],
      pays: null,
      bonuses: null,

      master: null,
    }
  },
  computed: {
    session() { return this.$store.state.session },
  },
  async created() {
    const { data } = await api.bonuses(this.session); console.log({ data })

    // error
    if (data.error && data.msg == 'invalid session') this.$router.push('/login')

    // success
    this.$store.commit('SET_NAME', data.name)
    this.$store.commit('SET_LAST_NAME', data.lastName)
    this.$store.commit('SET_AFFILIATED', data.affiliated)
    this.$store.commit('SET_ACTIVATED', data.activated)
    this.$store.commit('SET__ACTIVATED', data._activated)
    this.$store.commit('SET_PLAN', data.plan)
    this.$store.commit('SET_COUNTRY', data.country)
    this.$store.commit('SET_PHOTO', data.photo)
    this.$store.commit('SET_TREE', data.tree)

    this.plan = data.plan
    // let n

    const defaultPays = [
      { name: 'EJECUTIVO', payed: false, value: 60 },
      { name: 'PLATA', payed: false, value: 300 },
      { name: 'ORO', payed: false, value: 600 },
      { name: 'ZAFIRO', payed: false, value: 2000 },
      { name: 'RUBÍ', payed: false, value: 5000 },
      { name: 'ESMERALDA', payed: false, value: 10000 },
      { name: 'DIAMANTE', payed: false, value: 25000 },
      { name: 'DIAMANTE CORONA', payed: false, value: 50000 }
    ];

    let userPays = data.pays || [];

    userPays.forEach(pay => {
      if (pay.name === 'EJECUTIVO - PLATA') pay.name = 'PLATA'
      else if (pay.name === 'EJECUTIVO - ORO') pay.name = 'ORO'
      else if (pay.name === 'EMBAJADOR VISIONARIO') pay.name = 'ZAFIRO'
      else if (pay.name === 'EMBAJADOR ESTRELLA') pay.name = 'RUBÍ'
    });

    this.pays = defaultPays.map(dp => {
      const existing = userPays.find(up => up.name === dp.name);
      return existing ? existing : dp;
    });

    if(!data.bonuses) {
      data.bonuses = {
        DIAMANTE: [],
        'EMBAJADOR ELITE': [],
      }
    }
    this.bonuses  = data.bonuses

    // for(const pay of this.pays) {
    //   if(pay.name == 'star')              pay._name = 'ESTRELLA $15'
    //   if(pay.name == 'master')            pay._name = 'MASTER $30'
    //   if(pay.name == 'silver')            pay._name = 'PLATA $45'
    //   if(pay.name == 'gold')              pay._name = 'ORO $100'
    //   if(pay.name == 'sapphire')          pay._name = 'ZAFIRO $200'
    //   if(pay.name == 'RUBI')              pay._name = 'RUBI $300'
    //   if(pay.name == 'DIAMANTE')          pay._name = 'DIAMANTE $5.000'
    //   if(pay.name == 'DOBLE DIAMANTE')    pay._name = 'DOBLE DIAMANTE $10.000'
    //   if(pay.name == 'TRIPLE DIAMANTE')   pay._name = 'TRIPLE DIAMANTE $15.000'
    //   if(pay.name == 'DIAMANTE ESTRELLA') pay._name = 'DIAMANTE ESTRELLA $25.000'
    // }

    // this.sapphire = data.bonuses.sapphire
    // this.ruby     = data.bonuses.ruby
    // this.gold     = data.bonuses.gold
    // this.diamond  = data.bonuses.diamond

    // n = 9 - this.sapphire.length
    // for(let i = 0; i < n; i++) this.sapphire.push('-')

    // n = 12 - this.ruby.length
    // for(let i = 0; i < n; i++) this.ruby.push('-')

    // n = 24 - this.gold.length
    // for(let i = 0; i < n; i++) this.gold.push('-')

    // n = 9 - this.diamond.length
    // for(let i = 0; i < n; i++) this.diamond.push('-')
  },
}
</script>


<style>
  .fa-gem.green {
    color: #06d6a0;
  }

  .input.green {
    background-color: #06d6a0;
  }

  /*.input.star {
    background-color: yellow;
  }
  .input.master {
    background-color: #06d6a0;
  }
  .input.silver {
    background-color: #aaa;
  }
  .input.gold {
    background-color: #D4AF37;
  }
  .input.sapphire {
    background-color: blue;
  }*/
  /*.input.star {
    background-color: yellow;
  }
  .input.star {
    background-color: yellow;
  }
  .input.star {
    background-color: yellow;
  }
  .input.star {
    background-color: yellow;
  }
  .input.star {
    background-color: yellow;
  }
  .input.star {
    background-color: yellow;
  }*/
</style>
